import { ActionTypes } from "../contants/action-type";

const initialState = {
    invoices: [],
    invoice: {},

}

export const InvoiceReducer = (state = initialState, { type, payload }) => {
    switch (type) {
        case ActionTypes.LIST_INVOICE:
            return { ...state, invoices: payload };
        case ActionTypes.INVOICE_ORDER:
            return { ...state, invoice: payload };
        default:
            return state;
    }
}